import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteUpcomingEventsComponent } from './website-upcoming-events.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [WebsiteUpcomingEventsComponent],
  imports: [
    CommonModule,
    SharedModule,
  ],
  exports: [WebsiteUpcomingEventsComponent]
})
export class WebsiteUpcomingEventsModule { }
